export default __webpack_public_path__ + "static/media/PABS.c274c2f5.png";